import { Calendar, LocationPin } from '@arvesta-websites/icons';
import { useIntl } from 'react-intl';

import Cta from '../../Cta';
import { withErrorBoundary } from '../../ErrorBoundary';

import type { EventCardProps } from './EventCard';
import {
  StyledContentBox,
  StyledContentWrapper,
  StyledCta,
  StyledCtaWrapper,
  StyledDescription,
  StyledEventDate,
  StyledEventDetails,
  StyledEventLocation,
  StyledImageBox,
  StyledImageBoxLink,
  StyledTitle,
} from './Styled';

const VerticalEventCard = ({ title, shortDescription, image, link, displayDate, location }: EventCardProps) => {
  const intl = useIntl();

  return (
    <StyledContentWrapper>
      {image ? (
        <StyledImageBoxLink to={link}>
          <StyledImageBox
            sx={{
              backgroundImage: `url(${image})`,
            }}
          />
        </StyledImageBoxLink>
      ) : null}

      <StyledContentBox>
        <StyledTitle>
          <Cta to={link}>{title}</Cta>
        </StyledTitle>
        {displayDate || location ? (
          <StyledEventDetails>
            <StyledEventDate>
              {displayDate && <Calendar />}
              <span>{displayDate || null}</span>
            </StyledEventDate>
            <StyledEventLocation>
              {location && <LocationPin />}
              <span>{location || null}</span>
            </StyledEventLocation>
          </StyledEventDetails>
        ) : null}
        <StyledDescription>{shortDescription}</StyledDescription>

        <StyledCtaWrapper>
          <StyledCta to={link}>
            <span>{intl.formatMessage({ id: 'cards.event.link' })}</span>
          </StyledCta>
        </StyledCtaWrapper>
      </StyledContentBox>
    </StyledContentWrapper>
  );
};

export default withErrorBoundary(VerticalEventCard, { componentName: 'VerticalEventCard' });
